export default "__VITE_ASSET__EKcHhnFH__"